if (!customElements.get('sanalio-equation')) {
  customElements.define('sanalio-equation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.steps = [...this.querySelectorAll('[data-eq-step]')];
      this.panels = [...this.querySelectorAll('[data-eq-panel]')];
      this.pinned = false;
      this.open(this.dataset.initial);
      this.steps.forEach(button => {
        button.addEventListener('click', () => {
          const same = this.current === button.dataset.eqStep;
          if (same && this.pinned) { this.pinned = false; this.open(null); }
          else { this.open(button.dataset.eqStep); this.pinned = true; }
        }, { signal });
        button.addEventListener('pointerenter', event => {
          if (this.dataset.hover === 'true' && event.pointerType === 'mouse') {
            if (this.current !== button.dataset.eqStep) this.pinned = false;
            this.open(button.dataset.eqStep);
          }
        }, { signal });
      });
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse' && !this.pinned && this.dataset.hover === 'true') this.open(null);
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const trigger = this.steps.find(button => button.dataset.eqStep === this.current);
        this.pinned = false; this.open(null); trigger?.focus();
      }, { signal });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) { this.open(null); this.pinned = false; }
      }, { signal });
      this.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', event => {
        let id;
        try { id = decodeURIComponent(link.hash.slice(1)); } catch { return; }
        const target = document.getElementById(id);
        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        }
      }, { signal }));
    }
    open(value) {
      this.current = this.steps.some(button => button.dataset.eqStep === value) ? value : null;
      this.steps.forEach(button => button.setAttribute('aria-expanded', String(button.dataset.eqStep === this.current)));
      this.panels.forEach(panel => panel.hidden = panel.dataset.eqPanel !== this.current);
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

